import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { selectColor } from '@panel/commons/core';
import alertCircleIcon from '@panel/commons/assets/icons/AlertCircle.svg';
import alertCircleIconGray from '@panel/commons/assets/icons/widget-advertencias.svg';

const Alert = ({ nearEndPostingCount, ctaCallback }) => {
  const { t } = useTranslation();
  const ctaText = t(`panel.dashboard.alert.nearEnd.cta${nearEndPostingCount > 1 ? '.plural' : ''}`);
  const message = t(`panel.avisos.alert.postingsNearEnd.${nearEndPostingCount > 1 ? 'plural' : 'sing'}`, {
    value: nearEndPostingCount
  });
  const lowQualityMessage = t('panel.dashboard.alert.performance.message');
  const lowQualityCtaText = t('panel.dashboard.alert.performance.cta');
  return (
    <ContentLayout isPerformance={!nearEndPostingCount} data-panel='panel-dashboard-alertArea-container'>
      <div className='labelContainer'>
        <div className='iconContainer' data-panel='panel-dashboard-alertArea-icon'>
          <AlertCircle isPerformance={!nearEndPostingCount} />
        </div>
        <p data-panel='panel-dashboard-alertArea-textInfo'>{nearEndPostingCount ? message : lowQualityMessage}</p>
      </div>
      <div className='buttonsContainer'>
        <CloseButton
          onClick={() => {
            ctaCallback();
          }}
          data-panel='panel-dashboard-alertArea-button'
        >
          {nearEndPostingCount ? ctaText : lowQualityCtaText}
        </CloseButton>
      </div>
    </ContentLayout>
  );
};

const ContentLayout = styled.div`
  background-color: ${({ isPerformance }) => selectColor(isPerformance ? 'grayMedium' : 'alertRed')};
  height: 46px;
  color: ${({ isPerformance }) => selectColor(isPerformance ? 'grayDark' : 'feedbackWrong')};
  display: flex;
  padding: 0 26px 0 29px;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
  .labelContainer {
    align-items: center;
    display: flex;
    white-space: normal;
  }
  .buttonsContainer {
    display: flex;
    justify-content: flex-end;
  }
`;

const AlertCircle = styled.div`
  background-image: ${({ isPerformance }) => `url(${isPerformance ? alertCircleIconGray : alertCircleIcon})`};
  width: 16px;
  height: 16px;
  margin-right: 9px;
  margin-bottom: 3px;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
`;

const CloseButton = styled.div`
  cursor: pointer;
  font-size: 16px;
  font-weight: 600;
  line-height: 20.8px;
`;

export default Alert;
